import React, { useState } from 'react';

const EmailSettingsView = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleSave = () => {
    // Handle saving the email and password
    console.log('Email:', email);
    console.log('Password:', password);
  };

  return (
    <div style={{ padding: 20, backgroundColor: '#fff', borderRadius: 8, boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
      <h3 style={{ marginTop: 0, marginBottom: 20, color: '#1976d2', fontSize: 22 }}>Email Settings</h3>
      <div style={{ marginBottom: 15 }}>
        <label htmlFor="email" style={{ display: 'block', marginBottom: 5, fontWeight: '600', color: '#333' }}>Email</label>
        <input
          type="email"
          id="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={{ width: '50%', padding: '10px', borderRadius: 4, border: '1px solid #ccc', boxSizing: 'border-box' }}
        />
      </div>
      <div style={{ marginBottom: 20 }}>
        <label htmlFor="password" style={{ display: 'block', marginBottom: 5, fontWeight: '600', color: '#333' }}>Password</label>
        <input
          type="password"
          id="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={{ width: '50%', padding: '10px', borderRadius: 4, border: '1px solid #ccc', boxSizing: 'border-box' }}
        />
      </div>
      <button
        onClick={handleSave}
        style={{
          backgroundColor: '#4caf50',
          color: '#fff',
          padding: '12px 20px',
          border: 'none',
          borderRadius: 4,
          cursor: 'pointer',
          fontSize: 16,
          fontWeight: '600',
        }}
      >
        Save
      </button>
    </div>
  );
};

export default EmailSettingsView;